import React from 'react';
import {FieldViewProps} from "../../../render/view";
import ProjectIcon from "../../../../gd-ui/project-icon/project-icon-ui5"

type Props = FieldViewProps & {
    showIcon: boolean,
    params  : any
};

export default function FieldTemplateParent_View(props:Props) {


    const value     = props.field.getViewValue(props.model)
    const params    = props.params

    if (!value) {
        return (
            <div className={Classes("ui5-txt-less-important txt-truncate", props.className)}>
                No parent
            </div>
        )
    }

    const showIcon          = _.get(params, 'showIcon', false)
    // const projectName       = <div className="ui5-txt-default">{gd.session.projects.get(value)?.name}</div>
    const projectName       = <div className="ui5-txt-default">{gd.session.templatesList.get(value)?.name}</div>
    const icon              = showIcon ? <ProjectIcon className="m-r-10" size="16" projectId={value} colorize={false}/> : null

    const style : style           = {
        top         : '-5px',
        left        : '5px',
        position    : 'relative'
    }

    return (
        <div className={Classes("flex-row-left-center", props.className)}>
            {icon}{projectName}
            <div className="ui5-txt-not-important-tiny" style={style}>template</div>
        </div>
    )
}
